import { InsuranceVerificationStatus } from '../interfaces/heavyDutyMachinery/IHostInsurancePolicy';
import { PillTone } from '../theme/creamyTokens';
import { TRANSLATIONS } from './translations';

/**
 * How a policy's review state reads on a card. Exhaustive
 * Record<InsuranceVerificationStatus, X>, same convention as
 * BOOKING_STATUS_TONES and ACK_OUTCOME_TONES -- a new state should stop the
 * build here rather than render a blank pill.
 *
 * Pending is 'warning', not 'default': a host who typed in a franquicia and
 * assumes it protects their renters is in for a bad surprise, and a quiet
 * grey pill would let them keep assuming it.
 */
export const INSURANCE_VERIFICATION_TONES: Record<InsuranceVerificationStatus, PillTone> = {
  Pending: 'warning',
  Verified: 'success',
  Rejected: 'error',
};

export const INSURANCE_VERIFICATION_LABEL_KEYS: Record<InsuranceVerificationStatus, string> = {
  Pending: TRANSLATIONS.INSURANCE_VERIFICATION_PENDING,
  Verified: TRANSLATIONS.INSURANCE_VERIFICATION_VERIFIED,
  Rejected: TRANSLATIONS.INSURANCE_VERIFICATION_REJECTED,
};
